import './index_web.css';
import { View, LanguageBtn, Text } from '../../../component';
import Constants from '../../../constants';
import YNAnswerView from '../../component/yn_answer_view';
import InsightInfo from '../../component/insight_info';
import FantasyYesNoRule from '../../component/fantasy_yes_no_rule';
import YesNoVideo from '../../component/yes_no_video';
import DefaultContainer from '../../../container/default_container';
import { CounterWrapper } from '../../../component/header_with_timer';
import constants from '../../../constants';
import useTheme from '../../../utilities/hooks/theme';

const MyAnswerTabWeb = ({
  teamA,
  teamB,
  onCalledDeadline,
  matchStatus,
  verified,
  matchItem,
  isMatchScheduled,
  gameType,
  answerList,
  onChange2x,
  onChangeMyAnswer,
  language,
  onPressInsight,
  insightInfoModal,
  insight,
  ruleModal,
  onPressDismissRule,
  yesNoVideoModal,
  onPressDismissYNVideo,
  onPressOpenRule,
  onPressOpenYNVideo,
  onChangeSave,
  onPressCloseInsight
}: any) => {
  const { FantasyTheme: theme } = useTheme();

  const titleStyle = {
    fontFamily: 'Poppins !important',
    fontWeight: 600,
    fontSize: '18px',
    color: 'white',
    margin: '20px 0px 10px 0px'
  };
  const timerIconDimension = '20px';
  const guideWrapperStyle = {
    background: theme.myTeamsBtnWrapperBg
  };
  const previewBtnStyle = {
    border: `2px solid ${theme.createTeamPreviewBtnLabel}`,
    backgroundColor: theme.createTeamPreviewBtn,
    color: theme.createTeamPreviewBtnLabel
  };
  const saveBtnStyle = {
    backgroundColor: theme.createTeamPreviewBtnLabel
  };
  return (
    <DefaultContainer>
      <div className="my_answer_list_wrapper">
        <div style={{ display: 'flex' }}>
          <div style={{ width: '70%' }}>
            <View
              style={{
                // flexDirection: 'row',
                justifyContent: 'space-between',
                paddingLeft: '10%'
              }}>
              <Text style={titleStyle}>Select Your Answers</Text>

              <div className="my_answer_list_header_wrapper">
                <LanguageBtn />
                <div className="my_answer_list_team_name_wrapper">
                  <Text className="my_answer_list_team_name">{teamA?.shortName}</Text>
                  <Text className="my_answer_list_team_name">{'VS'}</Text>
                  <Text className="my_answer_list_team_name">{teamB?.shortName}</Text>
                </div>
                <View className="fantasy_cricket_header_timer_wrapper">
                  <View className="header-with-timer-icon-wrapper">
                    <Constants.Svgs.Timer width={timerIconDimension} height={timerIconDimension} />
                  </View>

                  {
                    <CounterWrapper
                      onCalledDeadline={onCalledDeadline}
                      matchStatus={matchStatus}
                      verified={verified}
                      matchItem={matchItem}
                      isMatchScheduled={isMatchScheduled}
                      gameType={gameType}
                    />
                  }
                </View>
              </div>
            </View>
            <View
              style={{
                position: 'relative',
                paddingLeft: '10%',

                height: '100%'
              }}>
              {answerList.map((item: any) => {
                const { sequence = 0 } = item;
                return (
                  <YNAnswerView
                    key={item.id}
                    item={item}
                    qNo={sequence}
                    editMode={true}
                    onChange2x={() => onChange2x(sequence - 1)}
                    onChangeMyAnswer={() => onChangeMyAnswer(sequence - 1)}
                    language={language}
                    onPressInsight={() => onPressInsight(sequence - 1)}
                  />
                );
              })}
            </View>
            <InsightInfo
              visible={insightInfoModal}
              onPressClose={onPressCloseInsight}
              insight={insight}
              language={language}
            />
            <FantasyYesNoRule
              visible={ruleModal}
              onPressDismiss={onPressDismissRule}
              language={language}
            />
            <YesNoVideo visible={yesNoVideoModal} onPressClose={onPressDismissYNVideo} />
          </div>
          <div style={{ width: '30%', display: 'flex', justifyContent: 'center' }}>
            <div className="my_answer_list_right_tab_container">
              <div className="my_answer_list_guide_wrapper" style={guideWrapperStyle}>
                <button
                  className="my_answer_list_points_system_btn"
                  style={previewBtnStyle}
                  onClick={onPressOpenRule}>
                  <img
                    src={constants.Images.yesNoInfo}
                    className="my_answer_list_points_system_img"
                  />
                  Points System
                </button>
                <button
                  className="my_answer_list_points_system_btn"
                  style={previewBtnStyle}
                  onClick={onPressOpenYNVideo}>
                  <img
                    src={constants.Images.yesNoInfo}
                    className="my_answer_list_points_system_img"
                  />{' '}
                  How to Play
                </button>
              </div>
              <button
                className="my_answer_list_save_btn"
                onClick={onChangeSave}
                style={saveBtnStyle}>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </DefaultContainer>
  );
};
export default MyAnswerTabWeb;
